import { render, staticRenderFns } from "./receivable-add-or-update.vue?vue&type=template&id=c5a0eef6&scoped=true"
import script from "./receivable-add-or-update.vue?vue&type=script&lang=js"
export * from "./receivable-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./receivable-add-or-update.vue?vue&type=style&index=0&id=c5a0eef6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a0eef6",
  null
  
)

export default component.exports